/* eslint-disable use-isnan */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
/* eslint-disable prefer-template */
import React, {
  useContext, useMemo, useEffect, useRef, useState
} from 'react'
import { useLocation } from 'react-router'
import { isMobile } from 'react-device-detect'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import { ACCOUNT_SETUP_STATE } from '@apps/redux/features/AccountSetupSlice'
import { PHONE_NUMBER_STATE } from '@apps/redux/features/PhoneNumberSlice'
import { PLANS_STATE, loadAllPlans, updatePlansState } from '@apps/redux/features/PlansSlice'
import { PAYMENT_STATE, getVouchers, updatePaymentStates } from '@apps/redux/features/PayAndReviewSlice'
import { useSelector, useDispatch } from 'react-redux'
import {
  PHONE_NUMBER_OPTIONS,
  PAYMENT_OPTIONS,
  SIM_OPTIONS,
  LANGUAGES_CODE,
  EN_TAX_TYPE_LABELS,
  FR_TAX_TYPE_LABELS,
  ANALYTICS_EVENT_TYPES,
  BOLD_WRAPPER_REGEX,
  FEATURE_SUPERSCRIPT_REGEX
} from '@apps/utils/constants'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { currencyFormatter } from '@apps/utils/CurrencyFormatter'
import Heading1 from '@apps/components/Typography/Heading1'
import Heading3 from '@apps/components/Typography/Heading3'
import BodySmall from '@apps/components/Typography/BodySmall'
import {
  getById,
  getLongTextFromPage,
  getShortTextFromPage,
  getImgByTitle,
  getByTitle,
  getBySlug
} from '@apps/utils/contentful'
import MarkdownRenderer from '@apps/components/MarkdownRenderer'
import ESimQrCard from '@apps/components/Cards/ESimQrCard'
import { containsProvince, getPromoNames } from '@apps/utils/common'
import { resolveBundleName, carriesBothLocales } from '@apps/utils/promoBundle'
import { formatSimField, sanitizeTextField } from '@apps/utils/formHelpers'
import { getPromotionAndValidationCodes } from '@apps/utils/requestPayloadHelper'
import { convertCentsToDollars } from '@apps/flows/activation/services/accountHelper'
import { Card, CardInfo, Icon, Image, Link, Spacer, Typography } from '@telus/koodo-ui-kit'
import Sites from '@/sites'
import useTagManagerInfo from '../../../../_engine/hooks/useTagManagerInfo'

const SectionHeader = ({ children }) => (
  <div className="mt-4 [&>*>*]:!min-h-0">
    <CardInfo variant={{ style: 'darkest' }}>
      <Typography
        variant={{
          inverse: true,
          size: 'h6'
        }}
        tokens={{ fontWeight: 600 }}>{children}</Typography>
    </CardInfo>
  </div>
)

const Row = ({ label, value, testId }) => (
  <div
    className="grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-y-1 gap-x-4 px-4 py-3 border-b border-gray-100 last:border-b-0"
    data-testid={testId}
  >
    <Typography
      variant={{
        size: 'medium'
      }}
      className="ml-4">{label}</Typography>

    <Typography variant={{
      size: 'medium'
    }}>{value}</Typography>
  </div>
)

const NoteRow = ({ noteLabel, value }) => (
  <div className="px-4 py-3">
    <Typography
      variant={{
        size: 'small'
      }}>
      <Typography
        variant={{
          size: 'small',
          bold: true
        }}>
        {noteLabel} &nbsp;
      </Typography>
      {value}
    </Typography>
  </div>
)

const MoneyRow = ({ label, value, isHeader = false, isBold = false }) => (
  <div
    className={`flex justify-between items-center px-4 py-3 border-b border-gray-100 last:border-b-0 ${isHeader ? 'bg-gray-100' : 'bg-white'
      }`}
  >
    <Typography variant={{
      size: 'medium',
      bold: isBold
    }}>
      {label}
    </Typography>
    {value && <Typography
      variant={{
        size: 'medium',
      }}>
      {value}
    </Typography>}
  </div>
)

const PrintButton = ({ onPress, label, widthSize = 'w-[187px]' }) => (
  <button
    type="button"
    aria-label={label}
    data-testid="transactionSummary-printButton"
    onClick={onPress}
    className={`inline-flex h-[56px] ${widthSize} items-center justify-center gap-2 rounded-[8px] border border-[#C9C8C8] bg-[#FAFAFA] px-4 py-1 text-black no-underline hover:bg-[#FAFAFA] hover:text-black hover:border-[#C9C8C8] active:bg-[#FAFAFA] active:text-black active:border-[#C9C8C8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-black transition-none`}
  >
    <span className="text-[16px] leading-[24px] font-semibold underline">{label}</span>
    <span className="mt-[1px]">
      <Icon
        variant={{
          size: 'small'
        }}
        accessibilityLabel="Success"
        icon="Receipt" />
    </span>
  </button>
)

const markdownComponentOverrides = {
  ul: ({ children }) => <>{children}</>,
  li: ({ children }) => <>{children}</>
}

// findAndValidatePromotions returns bundle fees in cents and only the fields
// the UI reads — normalize a response record into the shape the store keeps
// multiPromotionCodeInfo in.
const mapMultiPromotionCodeInfo = (promo) => {
  const bundles = promo?.bundles?.map((bundle) => {
    const { id, name, fee: rawFee, bundleType, unitType, numberMrc } = bundle
    return { id, name, fee: convertCentsToDollars(rawFee), bundleType, unitType, numberMrc }
  })
  return { id: promo?.id, description: promo?.description, bundles }
}

// findAndValidatePromotions takes a short province code, but the province ids
// held in state (phone number/tax province) are backend UUIDs — resolve those
// through the provinces list the same way LocationSelector does before display.
const resolveProvinceShortName = (value, provinceList) => {
  if (!value) return ''
  const raw = String(value).trim()
  if (raw.length <= 3) return raw
  return provinceList?.find((prov) => String(prov?.value) === raw)?.shortName || ''
}

const TransactionSummarySection = () => {
  const phoneNumberState = useSelector((state) => state.phoneNumberPage)
  const paymentState = useSelector((state) => state.payAndReviewPage)
  const {
    content: { pageContent, featureFlags },
    userType,
    user: { email },
    currentProvinceId
  } = useSelector((state) => state.common)

  const { isServiceFee911Enabled, enableMultiPromo } = featureFlags?.[0] || {}

  const pageRef = useRef(null)
  useEffect(() => {
    window.scrollTo(0, 0)

    if (pageRef.current) {
      pageRef.current.style.minHeight = '100vh'
    }
  }, [])

  const qrCodeRef = useRef(null)

  const dispatch = useDispatch()

  const {
    selectSimType: { simType, cost },
    simNumber,
    esimNumber
  } = useSelector((state) => state.simSelectionPage)

  const isPhysicalSim = simType === SIM_OPTIONS.H_SIM || simType === SIM_OPTIONS.P_SIM
  const formatSimNumber = (value) =>
    value ? formatSimField(sanitizeTextField(value)).formattedSim : value

  const {
    [ACCOUNT_SETUP_STATE.FIRST_NAME]: firstName,
    [ACCOUNT_SETUP_STATE.LAST_NAME]: lastName,
    [ACCOUNT_SETUP_STATE.BAN]: ban
  } = useSelector((state) => state.accountSetupPage)

  const {
    [PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER_OPTION]: numberSelectionOption,
    [PHONE_NUMBER_STATE.PROVINCE_ID]: provID
  } = phoneNumberState

  const plansPageState = useSelector((state) => state.plansPage)
  const { localizedPlanItem } = plansPageState
  const { [PLANS_STATE.PROMO]: planPromo, [PLANS_STATE.PLAN]: planSelected } = plansPageState

  const { postPaymentError, activationQRcode } = useSelector((state) => state.common)
  const location = useLocation()

  const {
    [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE]: referralCode,
    [PAYMENT_STATE.SELECTED_PAYMENT_OPTION]: paymentOption,
    [PAYMENT_STATE.CC_INFO.CREDIT_CARD_NUMBER]: creditCardNumber,
    [PAYMENT_STATE.SUMMARY.AMOUNT_TAX]: taxValue,
    [PAYMENT_STATE.SUMMARY.TAX_INFO]: taxInfo,
    [PAYMENT_STATE.SUMMARY.AMOUNT_OWING]: amountOwing,
    [PAYMENT_STATE.SUMMARY.AMOUNT_DUE]: amountDue,
    [PAYMENT_STATE.SUMMARY.AMOUNT_FUNDS]: amountFunds,
    [PAYMENT_STATE.PROMO.PROMOTION_CODE]: promoCode,
    [PAYMENT_STATE.PROMO.PROMOTION_CODE_INFO]: promoCodeInfo,
    [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_INFO]: friendReferralCodeInfo,
    [PAYMENT_STATE.AUTO_TOP_UPS]: autoTopUp,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo,
    [PAYMENT_STATE.VOUCHER.ADDED_VOUCHERS]: addedVouchers,
    [PAYMENT_STATE.SUMMARY.SERVICE_FEE_911]: serviceFee911,
    [PAYMENT_STATE.SUMMARY.SERVICE_FEE_NAME]: serviceFeeName,
    [PAYMENT_STATE.SUMMARY.ESTIMATED_RECURRING_CHARGE]: estimatedRecurringCharge
  } = useSelector((state) => state.payAndReviewPage)

  const [taxDetails, setTaxDetails] = useState([])

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.PROVINCES]: mappedProvinceList,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  // Needs `language`, so it must stay below the destructuring above.
  const isVoucherPayment = paymentOption === PAYMENT_OPTIONS.VOUCHER
    && addedVouchers?.length > 0

  const dueTodayDisplay = currencyFormatter(
    (isVoucherPayment ? amountDue : amountOwing) ?? 0,
    language
  )

  const tagManagerInfo = useTagManagerInfo()

  // eslint-disable-next-line camelcase
  const pushClickAnalytics = ({ click_text, promoCodeDescription, event_type, target_link, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text,
        promoCodeDescription
      }, event_type, event_click, target_link)
    )
  }

  useEffect(() => {
    const taxData = (taxInfo ?? []).map((data, index) => {
      const { label, value } = data
      const parts = label.split(' ')

      let updatedLabel
      if (language === LANGUAGES_CODE.EN) {
        updatedLabel = EN_TAX_TYPE_LABELS[parts[0]?.toUpperCase()]
      } else {
        updatedLabel = FR_TAX_TYPE_LABELS[parts[0]?.toUpperCase()]
      }

      if (updatedLabel) {
        parts[0] = updatedLabel
      }
      updatedLabel = parts.join(' ')

      return {
        id: index,
        label: updatedLabel,
        value: currencyFormatter(value, language)
      }
    })
    setTaxDetails(taxData)
  }, [language])

  // Records returned by findAndValidatePromotions only ever carry the locale
  // they were requested in (see promoBundle.js), so multiPromotionCodeInfo has
  // no French copy to fall back on — re-fetch it in the new language instead of
  // re-wording it locally.
  const multiPromoLocaleRef = useRef(language)
  useEffect(() => {
    const languageChanged = multiPromoLocaleRef.current !== language
    multiPromoLocaleRef.current = language

    if (!languageChanged || !multiPromotionCodeInfo?.length) return
    if (multiPromotionCodeInfo.every(carriesBothLocales)) return

    const multiPromotionAndValidationCodes = getPromotionAndValidationCodes(
      paymentState?.multiPromoCodes || []
    )
    if (!planSelected?.id || !multiPromotionAndValidationCodes) return

    const promoProvince = resolveProvinceShortName(paymentState?.taxProvince, mappedProvinceList)
      || resolveProvinceShortName(provID, mappedProvinceList)
      || resolveProvinceShortName(paymentState?.taxProvinceId, mappedProvinceList)
      || resolveProvinceShortName(currentProvinceId, mappedProvinceList)
    if (!promoProvince) return

    const revalidateMultiPromotionCodeInfo = async () => {
      const { data } = await brandServices.findAndValidatePromotions(
        planSelected.id,
        promoProvince,
        language,
        identity?.channelOrgCode,
        multiPromotionAndValidationCodes
      )
      const allHaveIds = data?.every(
        (promotion) => promotion.id !== undefined && promotion.id !== null
      )
      if (!allHaveIds) return

      dispatch(updatePaymentStates({
        [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: data.map(mapMultiPromotionCodeInfo)
      }))
    }
    revalidateMultiPromotionCodeInfo()
  }, [language])

  const text = useMemo(() => {
    if (!pageContent || !language || !userType) return {}
    const transactionSummaryPageContent = getById(pageContent, `transactionSummaryPage`)?.[language]
    // getById returns undefined when the entry is missing and {} when pageContent
    // is empty, so the language lookup can be undefined even though pageContent
    // itself is populated — destructuring that directly throws.
    const { longTextFields, images } = transactionSummaryPageContent || {}
    const fallbackPinataImage =
      getImgByTitle(transactionSummaryPageContent, 'pinata') ||
      getImgByTitle(transactionSummaryPageContent, 'pinata-consumer') ||
      getImgByTitle(transactionSummaryPageContent, 'pinata_FR') ||
      getImgByTitle(transactionSummaryPageContent, 'pinata-dealer') ||
      getByTitle(images, 'pinata-consumer') ||
      getByTitle(images, 'pinata_FR') ||
      getByTitle(images, 'pinata-dealer')

    return {
      accountNumber: getShortTextFromPage(transactionSummaryPageContent, 'accountNumber'),
      activationDate: getShortTextFromPage(transactionSummaryPageContent, 'activationDate'),
      amountPaid: getShortTextFromPage(transactionSummaryPageContent, 'amountPaid'),
      amountPaidToday: getShortTextFromPage(transactionSummaryPageContent, 'amountPaidToday'),
      autoPayCreditCard: getShortTextFromPage(transactionSummaryPageContent, 'autoPayCreditCard'),
      autoPayTitle: getShortTextFromPage(transactionSummaryPageContent, 'autoPayTitle'),
      createNumber: getShortTextFromPage(transactionSummaryPageContent, 'createNumber'),
      creditCard: getShortTextFromPage(transactionSummaryPageContent, 'creditCard'),
      creditCardDetails: getShortTextFromPage(transactionSummaryPageContent, 'creditCardDetails'),
      emailUsername: getShortTextFromPage(transactionSummaryPageContent, 'emailUsername'),
      friendReferralCode: getShortTextFromPage(transactionSummaryPageContent, 'friendReferralCode'),
      fundsAddedToYourAccount: getShortTextFromPage(
        transactionSummaryPageContent,
        'fundsAddedToYourAccount'
      ),
      name: getShortTextFromPage(transactionSummaryPageContent, 'name'),
      nextStepsTitle: getShortTextFromPage(transactionSummaryPageContent, 'nextStepsTitle'),
      note: getShortTextFromPage(transactionSummaryPageContent, 'note'),
      registeredAutoPay: getShortTextFromPage(transactionSummaryPageContent, 'registeredAutoPay'),
      notRegisteredAutoPay: getShortTextFromPage(
        transactionSummaryPageContent,
        'notRegisteredAutoPay'
      ),
      numberSelection: getShortTextFromPage(transactionSummaryPageContent, 'numberSelection'),
      paymentType: getShortTextFromPage(transactionSummaryPageContent, 'paymentType'),
      phoneNumber: getShortTextFromPage(transactionSummaryPageContent, 'phoneNumber'),
      province: getShortTextFromPage(transactionSummaryPageContent, 'province'),
      subtotal: getShortTextFromPage(transactionSummaryPageContent, 'subtotal'),
      tax: getShortTextFromPage(transactionSummaryPageContent, 'tax'),
      transactionSummary: getShortTextFromPage(transactionSummaryPageContent, 'transactionSummary'),
      transferNumber: getShortTextFromPage(transactionSummaryPageContent, 'transferNumber'),
      voucherCodes: getShortTextFromPage(transactionSummaryPageContent, 'voucherCodes'),
      eSimReady: getShortTextFromPage(transactionSummaryPageContent, 'eSimReady'),
      onceCompleteStepText: getShortTextFromPage(
        transactionSummaryPageContent,
        'onceCompleteStepText'
      ),
      planAndPayment: getShortTextFromPage(transactionSummaryPageContent, 'planAndPayment'),
      printSummary: getShortTextFromPage(transactionSummaryPageContent, 'printSummary'),
      savePageStep: getShortTextFromPage(transactionSummaryPageContent, 'savePageStep'),
      savePageStepInfo: getShortTextFromPage(transactionSummaryPageContent, 'savePageStepInfo'),
      scanQrStep: getShortTextFromPage(transactionSummaryPageContent, 'scanQrStep'),
      scanQrStepInfo: getShortTextFromPage(transactionSummaryPageContent, 'scanQrStepInfo'),
      selfServeAccountInformation: getShortTextFromPage(
        transactionSummaryPageContent,
        'selfServeAccountInformation'
      ),
      referralDiscountNote: getShortTextFromPage(
        transactionSummaryPageContent,
        'referralDiscountNote'
      ),
      simAndPhoneNumber: getShortTextFromPage(transactionSummaryPageContent, 'simAndPhoneNumber'),
      simCardActive: getShortTextFromPage(transactionSummaryPageContent, 'simCardActive'),
      simCardNumber: getShortTextFromPage(transactionSummaryPageContent, 'simCardNumber'),
      transferNumberNote: getLongTextFromPage(transactionSummaryPageContent, 'transferNumberNote'),
      yellowExclamation: getImgByTitle(transactionSummaryPageContent, 'yellow-exclamation'),
      creditcardUpdateMessageTitle: getShortTextFromPage(
        transactionSummaryPageContent,
        'creditcard-update-message-title'
      ),
      creditcardUpdateMessageDetails: getShortTextFromPage(
        transactionSummaryPageContent,
        'creditcard-update-message-details'
      ),
      creditcardUpdatselfServeLoginLink: getLongTextFromPage(
        transactionSummaryPageContent,
        'creditcard-update-message-selfservice-login-link'
      ),
      creditcardUpdatselfServeLoginText: getShortTextFromPage(
        transactionSummaryPageContent,
        'creditcard-update-message-selfservice-login-text'
      ),
      staticQrCode: getImgByTitle(transactionSummaryPageContent, 'static-qr-code'),
      mobileBgImage: getImgByTitle(transactionSummaryPageContent, 'mobile-bg-image'),
      pinataImage: fallbackPinataImage,
      shareQrCodeBtnLabel: getShortTextFromPage(
        transactionSummaryPageContent,
        'share-qr-code-btn-label'
      ),
      shareQrImageTitle: getShortTextFromPage(
        transactionSummaryPageContent,
        'share-qr-image-title'
      ),
      shareQrCodeTitle: getShortTextFromPage(transactionSummaryPageContent, 'share-qr-code-title'),
      shareQrCodeText: getShortTextFromPage(transactionSummaryPageContent, 'share-qr-code-text'),
      simTitle: getShortTextFromPage(transactionSummaryPageContent, 'sim-title'),
      eSIMHeading: getShortTextFromPage(transactionSummaryPageContent, 'esim-heading'),
      promo: getShortTextFromPage(transactionSummaryPageContent, 'promo'),
      selectedPlan: getShortTextFromPage(transactionSummaryPageContent, 'selectedPlan'),
      estimatedRecurringCharges: getShortTextFromPage(
        transactionSummaryPageContent,
        'estimatedRecurringCharges'
      ),
      accentImage: getByTitle(images, 'kpre-accent-3'),
      greenCircleCheck: getByTitle(images, 'green-check-mark'),
      greenCheckIcon: getByTitle(images, 'green-check-icon'),
      grapeInfoIcon: getByTitle(images, 'grape-info-icon'),
      eSimActivationChecklist: getBySlug(longTextFields, 'eSim-nextSteps-checklist')?.value,
      eSimActivationWarnings: getBySlug(longTextFields, 'eSim-nextSteps-warnings')?.value,
      pSimActivationChecklist: getBySlug(longTextFields, 'pSim-nextSteps-checklist')?.value,
      pSimActivationWarnings: getBySlug(longTextFields, 'pSim-nextSteps-warnings')?.value
    }
  }, [pageContent, language, userType])

  const subtitle = useMemo(() => {
    if (isPhysicalSim) return text?.simCardActive
    return text?.eSimReady
  }, [text, simType])

  const today = new Date()

  const getPhoneNumber = (state) => {
    return state[PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER_OPTION] ===
      PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER
      ? state[PHONE_NUMBER_STATE.CREATE_NEW_NUMBER.PHONE_NUMBER].label
      : `(${state[PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.PORT_IN_AREA_CODE]}) ${state[PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.PORT_IN_THREE_DIGITS]} - ${state[PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.PORT_IN_FOUR_DIGITS]}`
  }

  const {
    transactionSummary,
    printSummary,
    selfServeAccountInformation,
    name,
    emailUsername,
    friendReferralCode,
    province,
    note,
    referralDiscountNote,
    simAndPhoneNumber,
    simCardNumber,
    phoneNumber,
    numberSelection,
    createNumber,
    transferNumber,
    transferNumberNote,
    planAndPayment,
    selectedPlan,
    subtotal,
    amountPaid,
    amountPaidToday,
    paymentType,
    voucherCodes,
    fundsAddedToYourAccount,
    autoPayTitle,
    registeredAutoPay,
    notRegisteredAutoPay,
    autoPayCreditCard,
    activationDate,
    creditCard,
    creditCardDetails,
    accountNumber,
    promo,
    staticQrCode,
    shareQrCodeBtnLabel,
    shareQrImageTitle,
    shareQrCodeTitle,
    shareQrCodeText,
    simTitle,
    eSIMHeading,
    estimatedRecurringCharges,
    eSimActivationChecklist,
    eSimActivationWarnings,
    pSimActivationChecklist,
    pSimActivationWarnings,
    pinataImage
  } = text

  const localizedPlans = useMemo(() => {
    const usePhoneNumberProvince =
      numberSelectionOption === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER && provID
    const selectedProv = usePhoneNumberProvince
      ? mappedProvinceList?.find((pr) => pr.value === provID)?.shortName
      : mappedProvinceList?.find((pr) => pr.value === currentProvinceId)?.shortName
    const plansObject = localizedPlanItem?.[language]?.find(Boolean)
    const { plans: portalPlanList } = plansObject || {}
    const newSelectedPlan = plansObject?.plans?.find((plan) => {
      return plan?.id === planSelected?.id
    })
    if (newSelectedPlan) {
      dispatch(
        updatePlansState({
          [PLANS_STATE.PLAN]: newSelectedPlan
        })
      )
    }
    return portalPlanList?.filter(
      (pl) => !pl.province || containsProvince(pl.province, selectedProv)
    )
  }, [
    mappedProvinceList,
    provID,
    currentProvinceId,
    language,
    localizedPlanItem,
    numberSelectionOption
  ])

  useEffect(() => {
    dispatch(loadAllPlans(localizedPlans))
  }, [localizedPlans])

  const maskCreditCard = (value) => {
    const lastFourDigits = value.substr(-4)

    return `••••••••••••${lastFourDigits}`
  }

  const plan = planSelected

  // Plans selected through the plan MFE are mapped by mfePlanToHostPlan, which
  // carries no `features` array (only the legacy portal plan list has one), so
  // the bullet list has to tolerate its absence — same guard Plan/index.js uses.
  const planFeatures = Array.isArray(plan?.features) ? plan.features : []

  const activationProvinceId = useMemo(() => {
    let provinceId = currentProvinceId

    const usePhoneNumberProvince =
      numberSelectionOption === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER
    const useTaxProvince = isServiceFee911Enabled && !!paymentState?.taxProvinceId

    if (useTaxProvince) {
      provinceId = paymentState.taxProvinceId
    } else if (usePhoneNumberProvince) {
      provinceId = provID
    }
    return provinceId
  }, [
    mappedProvinceList,
    numberSelectionOption,
    isServiceFee911Enabled,
    paymentState?.taxProvinceId
  ])

  // Bails out below every hook call: `plan` comes from redux, so returning
  // before a hook made the hook count change between renders once it arrived,
  // which React rejects outright.
  if (!plan) {
    return <></>
  }

  const provinceName = () => {
    if (mappedProvinceList && mappedProvinceList?.length > 0 && activationProvinceId) {
      const result =
        mappedProvinceList.find((prov) => {
          return prov.value?.toLowerCase() === activationProvinceId?.toLowerCase()
        }) || {}

      const { label: { en, fr } = '' } = result
      return language === 'en' ? en : fr
    }
    return null
  }

  const handleShareQrCode = async () => {
    try {
      const imgElement = qrCodeRef.current.querySelector('img')
      const dataUrl = imgElement.src

      if (navigator.share) {
        const blob = await fetch(dataUrl).then((res) => res.blob())
        const filesArray = [new File([blob], `${shareQrImageTitle}.png`, { type: blob.type })]

        await navigator.share({
          files: filesArray,
          title: shareQrCodeTitle,
          text: shareQrCodeText
        })
      } else {
        alert('Web Share API is not supported in your browser.')
      }
    } catch (error) {
      console.error('Error sharing:', error)
    }
  }

  const getMultiPromoInfo = (multiPromoInfo) => {
    return (
      <>
        {multiPromoInfo && (
          <>
            {multiPromoInfo.map((promoInfo) => {
              return (
                <>
                  {promoInfo && promoInfo.bundles && (
                    <>
                      {promoInfo.bundles.map((bundle) => {
                        // eslint-disable-next-line no-shadow
                        const { fee = 0, id } = bundle
                        return (
                          <MoneyRow
                            key={id}
                            label={resolveBundleName(bundle, language)}
                            value={Math.abs(fee) > 0 ? currencyFormatter(fee, language) : ''}
                          />
                        )
                      })}
                    </>
                  )}
                </>
              )
            })}
          </>
        )}
      </>
    )
  }


  const normalizeWrappedBoldText = (value = '') => {
    const trimmed = `${value}`.trim()
    // Support both {{text}} and {{*text*}} authoring styles.
    if (trimmed.startsWith('*') && trimmed.endsWith('*') && trimmed.length > 1) {
      return trimmed.slice(1, -1).trim()
    }
    return trimmed
  }

  // Footnote markers (e.g. "speed⁴,⁵") are authoring metadata, not part of
  // the label shown to users, so strip them before the feature is rendered.
  const stripSuperscriptReferences = (feature) => {
    if (typeof feature !== 'string') return feature
    return feature.replace(FEATURE_SUPERSCRIPT_REGEX, '')
  }

  const buildFeatureContentBlock = (feature) => {
    if (typeof feature !== 'string') return feature
    // Strip footnote markers first so they can't end up inside a bold segment.
    const featureWithoutSuperscripts = stripSuperscriptReferences(feature)
    const hasBoldWrapper = BOLD_WRAPPER_REGEX.test(featureWithoutSuperscripts)
    // Reset regex cursor because test() with /g is stateful.
    BOLD_WRAPPER_REGEX.lastIndex = 0

    const withBoldSegments = hasBoldWrapper
      ? featureWithoutSuperscripts.replace(BOLD_WRAPPER_REGEX, (_match, wrappedText) => {
        const normalizedText = normalizeWrappedBoldText(wrappedText)
        return `**${normalizedText}**`
      })
      : featureWithoutSuperscripts

    return withBoldSegments
  }

  const isServiceFeeApplicable = () => {
    if (!isServiceFee911Enabled || !serviceFeeName || !serviceFee911) return false
    const serviceFee = parseFloat(serviceFee911)
    return !!serviceFeeName && serviceFee > 0
  }

  const renderNextStepsContent = (content) => {
    if (!content) return null
    return (
      <MarkdownRenderer
        markdown={content}
        onLinkClick={(text, url) =>
          pushClickAnalytics({
            click_text: text,
            promoCodeDescription: getPromoNames([planPromo, ...multiPromotionCodeInfo]),
            event_type: text + ' clicked',
            target_link: url
          })
        }
        paragraphClassForIndex={() => 'text-copy text-sm font-body leading-6 mb-1'}
        listClass="pl-4 mb-2 leading-5 font-body text-xs"
        nestedListClass="pl-4 mb-1 leading-5 font-body text-xs"
      />
    )
  }

  return (
    <div className="px-4 sm:px-0">
      <div className="mt-16 flex flex-col-reverse md:flex-row md:items-start">
        <div className="mb-4 md:mb-0 md:w-7/12">
          <Heading1>{transactionSummary}</Heading1>
        </div>
        {!isMobile && (<div
          className="mb-4 md:mb-0 print:hidden flex items-center justify-start md:w-4/12 md:ml-auto md:justify-end"
        >
          <PrintButton
            label={printSummary}
            onPress={() => {
              pushClickAnalytics({ click_text: printSummary, promoCodeDescription: getPromoNames([planPromo, ...multiPromotionCodeInfo]), event_type: 'printSummary clicked' })
              window.print()
            }}
          />
        </div>)}
      </div>
      <Spacer space={4} />
      <div>
        <div className="flex flex-row items-center md:w-7/12">
          <Heading3>{subtitle}</Heading3>
        </div>
        <Spacer space={4} />
        <div>
          <div className="flex flex-col md:flex-row md:items-start font-body text-copy">
            <div className="md:w-7/12">
              {(simType === SIM_OPTIONS.H_SIM || simType === SIM_OPTIONS.P_SIM) && (
                <>
                  {renderNextStepsContent(pSimActivationChecklist)}
                </>
              )}
              {simType === SIM_OPTIONS.E_SIM && (
                <>
                  {renderNextStepsContent(eSimActivationChecklist)}
                </>
              )}
            </div>
            {simType === SIM_OPTIONS.E_SIM ? <div className="md:w-5/12 mt-8 md:mt-8 flex justify-center md:justify-end relative md:bottom-[67px]">
              {userType === Sites.consumer && simType === SIM_OPTIONS.E_SIM && (
                <ESimQrCard qrCode={activationQRcode} qrCodeRef={qrCodeRef} />
              )}
              {userType === Sites.dealer && simType === SIM_OPTIONS.E_SIM && (
                <ESimQrCard qrCode={staticQrCode?.url} qrCodeRef={qrCodeRef} />
              )}
            </div> :
              <div className="md:w-5/12 mt-4 md:mt-8 flex justify-center md:justify-end relative md:bottom-[67px]">
                <Image
                  alt="Pinata"
                  src={pinataImage?.url}
                  className="inline-block h-auto max-w-[220px] w-full"
                />
              </div>}

          </div>
        </div>
        {isMobile && (
          <div className="print:hidden">
            <Spacer space={8} />
            <PrintButton
              label={printSummary}
              widthSize="w-full"
              onPress={() => {
                pushClickAnalytics({ click_text: printSummary, promoCodeDescription: getPromoNames([planPromo, ...multiPromotionCodeInfo]), event_type: 'printSummary clicked' })
                window.print()
              }}
            />
          </div>
        )}
      </div>


      {postPaymentError && (
        <>
          <Spacer space={8} />

          <Card
            variant={{
              style: 'warning',
              padding: 'compact'
            }}
          >
            <div className="flex flex-row">
              <div className="mr-2 mt-1">
                <Icon
                  variant={{
                    size: 'small',
                    color: 'warning'
                  }}
                  accessibilityLabel="Warning"
                  icon="ExclamationTriangle"
                />
              </div>
              <Typography>
                <Typography variant={{ bold: true }}>
                  {text?.creditcardUpdateMessageTitle}. &nbsp;
                </Typography>
                {text?.creditcardUpdateMessageDetails}
                <Link
                  target="_blank"
                  className="font-h1"
                  href={text?.creditcardUpdatselfServeLoginLink}
                >
                  {text?.creditcardUpdatselfServeLoginText}
                </Link>
              </Typography>
            </div>
          </Card>
        </>
      )
      }
      <Spacer space={6} />
      <div>
        <div>
          <SectionHeader>{selfServeAccountInformation}</SectionHeader>
          <div className="py-4 bg-white">
            <Row label={accountNumber} testId="transactionSummary-ban" value={ban} />
            <Row label={name} testId="transactionSummary-name" value={`${firstName} ${lastName}`} />
            <Row label={emailUsername} testId="transactionSummary-email" value={email} />
            <Row label={province} testId="transactionSummary-province" value={provinceName()} />
            {referralCode && friendReferralCodeInfo && (
              <>
                <Row label={friendReferralCode} testId="transactionSummary-friendReferralCode" value={referralCode} />
                <NoteRow noteLabel={note} value={referralDiscountNote}
                />
              </>
            )}
          </div>
        </div>
        <Spacer space={4} />
        <div>
          <SectionHeader>{simAndPhoneNumber}</SectionHeader>
          <div className="py-4 bg-white">
            <Row label={simCardNumber} testId="transactionSummary-sim" value={formatSimNumber(isPhysicalSim ? simNumber : esimNumber)} />
            <Row label={phoneNumber} testId="transactionSummary-phone" value={getPhoneNumber(phoneNumberState)} />
            <Row label={numberSelection} testId="transactionSummary-numberSelection" value={numberSelectionOption === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER ? createNumber : transferNumber} />
            <NoteRow noteLabel={note} value={transferNumberNote} />
          </div>
        </div>
        <Spacer space={4} />
        <div>
          <SectionHeader>{planAndPayment}</SectionHeader>
          <div className="py-4 border-b border-gray-200 bg-white">
            <div className="px-4 pb-4">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <Typography>{selectedPlan}</Typography>
                  <div className="mt-1">
                    <Typography
                      variant={{ size: 'h6' }}>
                      {`${plan?.name}`}
                    </Typography>
                  </div>
                </div>
                <Typography
                  variant={{ size: 'medium' }}>
                  {currencyFormatter(plan?.value, language)}
                </Typography>
              </div>
              <ul className="col-span-2 ml-4 list-disc list-outside text-copy">
                {planFeatures.map((feature, index) => {
                  return (
                    <li key={`${feature}-${index}`}>
                      <MarkdownRenderer
                        markdown={buildFeatureContentBlock(feature)}
                        linkPrimaryClass={false}
                        paragraphClassForIndex={() => 'text-xs text-copy font-body'}
                        componentOverrides={markdownComponentOverrides}
                      />
                    </li>
                  )
                })}
              </ul>
            </div>
            <Spacer space={2} />

            {/* Service fee applicable */}
            {isServiceFeeApplicable() && (
              <>
                <MoneyRow label="Service Fee" isHeader />
                <MoneyRow label={serviceFeeName} value={currencyFormatter(serviceFee911, language)} />
              </>
            )}
            {/* Plan Promo */}

            {planPromo?.bundles?.length > 0 && !promoCode && multiPromotionCodeInfo?.length === 0 && (
              <>
                <MoneyRow label={promo} isHeader />
                {planPromo.bundles.map((bundle, i) => {
                  const { fee = 0 } = bundle
                  return (
                    <MoneyRow key={i} label={resolveBundleName(bundle, language)} value={Math.abs(fee) > 0 ? currencyFormatter(fee, language) : ''} />
                  )
                })}
              </>
            )}
            {/* E-Sim detail & Charges */}

            {simType === SIM_OPTIONS.E_SIM && (
              <>
                <MoneyRow label={simTitle} isHeader />
                <MoneyRow label={eSIMHeading} value={currencyFormatter(cost, language)} />
              </>
            )}
            {/* Plan Promo */}

            {promoCode && promoCodeInfo?.bundles?.length > 0 && (
              <>
                <MoneyRow label={promo} isHeader />
                {promoCodeInfo.bundles.map((bundle) => {
                  const { fee = 0 } = bundle
                  return (
                    <MoneyRow label={resolveBundleName(bundle, language)} value={Math.abs(fee) > 0 ? currencyFormatter(fee, language) : ''} />
                  )
                })}
              </>
            )}

            {/* Multi Promotion Code Info */}

            {enableMultiPromo &&
              multiPromotionCodeInfo?.length > 0 && (
                <>
                  <MoneyRow label={promo} isHeader />
                  {getMultiPromoInfo(multiPromotionCodeInfo)}
                </>
              )}

            {/* Subtotal */}
            <MoneyRow label={subtotal} value={currencyFormatter(amountOwing - taxValue, language)} isHeader />

            {/* Taxes */}
            {Number(taxValue) !== NaN && (
              <>
                <BodySmall />
                {paymentOption === PAYMENT_OPTIONS.CREDIT_CARD &&
                  addedVouchers?.length === 0 &&
                  taxDetails?.map(({ label, value }) => (
                    <MoneyRow label={label} value={value} />
                  ))}
              </>
            )}

            {/* Amount paid Today */}
            <MoneyRow label={isServiceFee911Enabled ? amountPaidToday : amountPaid} value={dueTodayDisplay} isHeader />
            {isServiceFee911Enabled && (<MoneyRow label={estimatedRecurringCharges} value={currencyFormatter(estimatedRecurringCharge, language)} />)}

            {/* Payment Information */}
            <div>
              <div className="bg-white">
                <div>
                  <Row
                    label={paymentType}
                    value={paymentOption === PAYMENT_OPTIONS.CREDIT_CARD ? creditCard : voucherCodes}
                    testId="transactionSummary-paymentType"
                  />

                  {paymentOption === PAYMENT_OPTIONS.VOUCHER && (<Row
                    label={voucherCodes}
                    value={getVouchers(addedVouchers)}
                    testId="transactionSummary-vouchers" />
                  )}
                  {amountFunds > 0 && (<Row
                    label={fundsAddedToYourAccount}
                    value={currencyFormatter(amountFunds, language)}
                    testId="transactionSummary-fundsAdded" />
                  )}
                  {paymentOption === PAYMENT_OPTIONS.CREDIT_CARD && (<Row
                    label={creditCardDetails}
                    value={maskCreditCard(creditCardNumber)}
                    testId="transactionSummary-creditCardDetails" />
                  )}
                  <Row
                    label={autoPayTitle}
                    value={autoTopUp ? registeredAutoPay : notRegisteredAutoPay}
                    testId="transactionSummary-autoPay"
                  />

                  {autoTopUp && paymentOption === PAYMENT_OPTIONS.VOUCHER && (<Row
                    label={autoPayCreditCard}
                    value={maskCreditCard(creditCardNumber)}
                    testId="transactionSummary-autoPayCreditCard" />
                  )}
                  <Row
                    label={activationDate}
                    value={`${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()}`}
                    testId="transactionSummary-activationDate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionSummarySection

